import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "packet-page common-page"
};
const _hoisted_2 = {
  class: "packet-content flex"
};
const _hoisted_3 = {
  class: "top-list"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "role-item-name text"
};
const _hoisted_6 = {
  class: "second-header flex"
};
const _hoisted_7 = {
  class: "title"
};
const _hoisted_8 = {
  class: "second-category-list"
};
const _hoisted_9 = {
  class: "second-item flex"
};
const _hoisted_10 = {
  class: "name"
};
const _hoisted_11 = {
  class: "second-control"
};
import { ref, onMounted, markRaw } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getPageSize, getoffset } from '@/utils/math';
import noData from '@/components/no-data.vue';
import secondCategoryDialog from './components/category/second-category-dialog.vue';
import { QuestionFilled } from '@element-plus/icons-vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { getCaseCategoryListApi, getDoctorDepListApi, deleteSecondCaseCategoryApi } from '@/service/modules/case';
export default /*@__PURE__*/_defineComponent({
  __name: 'category',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const doctorDepList = ref([]);
    const categoryList = ref([]);
    const topActiveIndex = ref(0);
    const topCategoryActiveData = ref({});
    const scrollHeight = ref(0);
    const secondCategoryDialogVisible = ref(false);
    const secondCategoryDialogType = ref('add');
    const secondCategoryDialogData = ref({});
    getDoctorDepList();
    async function getDoctorDepList() {
      try {
        let res = await getDoctorDepListApi();
        doctorDepList.value = res.data;
        topCategoryActiveData.value = doctorDepList.value[topActiveIndex.value];
        getCaseCategoryList(topCategoryActiveData.value.id);
      } catch {}
    }
    // getCaseCategoryList()
    async function getCaseCategoryList(id) {
      try {
        let res = await getCaseCategoryListApi(id);
        categoryList.value = res.data;
      } catch {}
    }
    function handleTopCategorySelect(item, index) {
      topActiveIndex.value = index;
      topCategoryActiveData.value = item;
      getCaseCategoryList(topCategoryActiveData.value.id);
    }
    /**
     * 二级分类
    */
    function handleSecondCategoryDialog(type, item) {
      secondCategoryDialogType.value = type;
      if (item) secondCategoryDialogData.value = item;
      secondCategoryDialogVisible.value = true;
    }
    function handleCloseSecondCategoryDialog() {
      secondCategoryDialogData.value = {};
      secondCategoryDialogType.value = 'add';
      secondCategoryDialogVisible.value = false;
    }
    function handleDeleteSecondCategory(id) {
      ElMessageBox.confirm('此操作将永久删除该数据, 是否继续？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        icon: markRaw(QuestionFilled)
      }).then(async () => {
        try {
          await deleteSecondCaseCategoryApi(id);
          ElMessage.success('删除成功');
          getDoctorDepList();
        } catch {}
      }).catch(() => {});
    }
    onMounted(() => {
      let pageArea = getPageSize();
      let offsetArea = getoffset('.packet-content');
      scrollHeight.value = pageArea.height - offsetArea.top - 20;
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_link = _resolveComponent("el-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[6] || (_cache[6] = _createElementVNode("div", {
        class: "page-title"
      }, "案例分类", -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: "top-category",
        style: _normalizeStyle({
          height: `${scrollHeight.value}px`
        })
      }, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "top-title"
      }, "科室", -1)), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(doctorDepList.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["top-item", {
            active: topActiveIndex.value === index
          }]),
          key: index,
          onClick: $event => handleTopCategorySelect(item, index)
        }, [_cache[1] || (_cache[1] = _createElementVNode("div", {
          class: "icon"
        }, [_createElementVNode("i", {
          class: "iconfont yiqiyong-renqun text"
        })], -1)), _createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1)], 10, _hoisted_4);
      }), 128))])], 4), _createElementVNode("div", {
        class: "second-category",
        style: _normalizeStyle({
          height: `${scrollHeight.value}px`
        })
      }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(topCategoryActiveData.value.name), 1), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = $event => handleSecondCategoryDialog('add'))
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("添加二级分类")])),
        _: 1
      })]), _createElementVNode("div", _hoisted_8, [categoryList.value && categoryList.value.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(categoryList.value, item => {
        return _openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(item.name) + " ---（" + _toDisplayString(item.display) + "）", 1), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_link, {
          type: "primary",
          style: {
            "margin-right": "10px"
          },
          onClick: $event => handleSecondCategoryDialog('edit', item)
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("编辑")])),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_link, {
          type: "danger",
          onClick: $event => handleDeleteSecondCategory(item.id)
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("删除")])),
          _: 2
        }, 1032, ["onClick"])])]);
      }), 256)) : (_openBlock(), _createBlock(noData, {
        key: 1
      }))])], 4)]), _createVNode(secondCategoryDialog, {
        "dialog-visible": secondCategoryDialogVisible.value,
        "dialog-type": secondCategoryDialogType.value,
        "item-data": secondCategoryDialogData.value,
        "parent-list": doctorDepList.value,
        "parent-id": topCategoryActiveData.value.id,
        onCloseDialog: handleCloseSecondCategoryDialog,
        onRestData: getDoctorDepList
      }, null, 8, ["dialog-visible", "dialog-type", "item-data", "parent-list", "parent-id"])]);
    };
  }
});